import React from 'react'
import { FormGroup, FormText, Label, Badge, Input } from 'reactstrap'
import PropTypes from 'prop-types'

const propTypes = {
  name               : PropTypes.string.isRequired,
  label              : PropTypes.string,
  formText           : PropTypes.string,
  required           : PropTypes.bool,
  formGroupClassName : PropTypes.string,
  imageUrl           : PropTypes.string,
  expectedDimension  : PropTypes.object.isRequired,
  formikBag          : PropTypes.object
}

const ProductPatternImageUploadField = ({
  label,
  formText,
  required,
  formGroupClassName,
  imageUrl,
  formikBag,
  expectedDimension,
  name
}) => {
  const onChange = (event) => {
    const input  = event.target.files[0]
    const image  = new Image()
    image.src    = URL.createObjectURL(input)
    image.onload = () => {
      let isWidthValid  = image.width === expectedDimension.width
      let isHeightValid = image.height === expectedDimension.height

      if (!(isWidthValid && isHeightValid)) {
        formikBag.setFieldError(name, `resolusi gambar harus ${expectedDimension.width} x ${expectedDimension.height}`)
        return
      }

      let output = document.getElementById('output')
      output.src = image.src
    }

    formikBag.setFieldValue(name, input)
  }

  return (
    <>
      <FormGroup className={ formGroupClassName }>
        {
          label
            ? (
              <Label
                for={ name }
                className='text-gray-light text-capitalize'
              >
                <strong>{ label }</strong>
                {
                  required ? <Badge color='warning' className='ml-1'>Required</Badge> : null
                }
              </Label>
            )
            : null
        }

        <Input
          type='file'
          accept='image/*'
          onChange={ (event) => { onChange(event) } }
        />
        <FormText>{ formText }</FormText>
        <div className='text-danger'>{ formikBag.errors && formikBag.errors[`${name}`] }</div>

        <img
          src={ imageUrl }
          id='output'
          className='mt-3'
          width='150'
          alt=''
        />
      </FormGroup>
    </>
  )
}

ProductPatternImageUploadField.propTypes = propTypes

export default ProductPatternImageUploadField
